import { api } from './client';

export interface AuditRow {
  id: number;
  ts: number;
  admin_id: string | null;
  admin_email: string | null;
  method: string;
  path: string;
  status: number | null;
  ip: string | null;
  section: string | null;
  action: string | null;
  entity_type: string | null;
  entity_id: string | null;
  body: string | null;
  changes: string | null;
}

export interface AuditPage {
  rows: AuditRow[];
  total: number;
  page: number;
  limit: number;
}

export interface AuditQuery {
  page?: number;
  limit?: number;
  admin_id?: string;
  section?: string;
  method?: string;
  entity_type?: string;
  entity_id?: string;
  search?: string;
  from?: number;
  to?: number;
}

export const getAuditLog = (q: AuditQuery = {}) => {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v == null || v === '') continue;
    params.set(k, String(v));
  }
  const qs = params.toString();
  return api.get<AuditPage>(`/admin/audit${qs ? `?${qs}` : ''}`);
};
